import type { WSuiteDetailsCardView } from '@zola/svc-web-api-ts-client';
import ApiService from '~/util/api';

/**
 * @see http://34.192.78.81:9140/swagger-ui/index.html#/CardCatalog/getSuiteForPdp
 */
export const fetchCardSuiteDetails = (
  cardSuiteUUID: string,
  isAdminView = false
): Promise<WSuiteDetailsCardView> =>
  // @see getSuiteForPdp
  ApiService.post(`/web-api/v1/card-catalog/suite/details/${cardSuiteUUID}`, {
    show_unlisted: !!isAdminView,
  });
